import { useSelector } from 'react-redux'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import InsufficientPermission from '../../custom/InSufficientPermission'
import { GradeUsersList } from './GradeUsersList'

function GradeUsersPage() {

  const userPermisiions = useSelector((state) => state?.permission)
  let viewPermission = true

  if (userPermisiions?.modules?.length > 0) {
    const currentModulePermission = userPermisiions.modules.find(
      (element) => element.moduleId === '4'
    )?.permissions
    viewPermission =
      currentModulePermission?.find((element) => element.name === 'VIEW')
        ?.isEnable ?? false
  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        {viewPermission ? (
          <div className='container-fluid mt--7'>
            <div className='row'>
              <div className='col text-left'>
                <div className='card shadow'>
                  <GradeUsersList />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <InsufficientPermission />
        )}
      </div>
    </>
  )
}

export default GradeUsersPage
